/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:33:15
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginTabs from 'bee-tabs';
import { getSysFieldid } from '@platform/api';
require('bee-tabs/build/Tabs.css');
import hotkeys from './hotkeys';

const { TabPane: OriginTabPane } = OriginTabs;
require('./index.less');
class TabPane extends Component {
    render() {
        let { style = {}, ...others } = this.props;
        return <OriginTabPane {...others} style={{ ...style, color: '#000' }} />;
    }
}
// @hotkeys(true, { prevTab: "shift+left", nextTab: "shift+right" })
class Tabs extends Component {
    render() {
        let { children, className, ...others } = this.props;
        if (!Array.isArray(children)) {
            this.props.children = [children];
        }
        return (
            <div fieldid={getSysFieldid('tabs-area')} className={` ${className}  nc-tabs`}>
                <OriginTabs
                    fieldid={getSysFieldid('tabs-area')}
                    ref={obj => (this.tabs = obj)} {...others}
                    className="lightapp-component-tabs"
                >
                    {this.props.children.filter((item) => !!item).map((e, i) => {
						if (e.type.name === TabPane.name) {
							return e;
						}
					})}
                </OriginTabs>
            </div>
        );
    }
}
Tabs.TabPane = TabPane;

export default Tabs;
